// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.campaigns-table {
    width: 100%;
}

tbody:before {
    content: "@";
    display: block;
    line-height: 10px;
    text-indent: -99999px;
}


.first_th {
    border-radius: 10px 0 0 10px;
}

.last_th {
    border-radius: 0 10px 10px 0;
}

.campaign_list_title_component {
    display: flex;
    flex-direction: row;
    width: 100%;
    justify-content: space-between;
    align-items: center;
}

.delete_filters {
    padding: 5px 10px;
    background-color: var(--bg);
    border-radius: 4px;
    border: solid 1px var(--bg);
    color: var(--text-primary);
}

.delete_filters:hover {
    padding: 5px 10px;
    background-color: #afb7ff;
    border-radius: 4px;
    border: solid 1px var(--primary);
    color: var(--text-primary);
}

/* styles.css (ou le nom de votre fichier CSS) */
.custom-select {
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    background-color: var(--bg-card);
    border: 1px solid var(--border);
    padding: 5px 10px;
    border-radius: 4px;
    font-size: 14px;
    width: min-content;
    cursor: pointer;
    outline: none;
}

/* Style de survol lorsque la souris passe sur le select */
.custom-select:hover {
    border-color: var(--border);
}

/* Style de focus lorsque le select est en focus */
.custom-select:focus {
    border-color: var(--primary);
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}


th {
    background-color: var(--bg);
    padding: 20px 10px;
    text-align: left;
}

.payout_modalContainer {
    position: block;
    width: 100%;
    height: 100%;
    background-color: aqua;
}

.campaigns_filter_component {
    display: flex;
    align-items: center;
    justify-content: end;
    gap: 10px;
    width: 20%;
}

.campaigns_filter_component input {
    width: max-content;
    border: 1px solid var(--border);
    padding: 5px 10px;
    border-radius: 4px;
}

.modal_input_container {
    display: flex;
    flex-direction: column;
    position: relative;
    gap: 15px;
    width: 100%;
}

.modal_input_container input {
    max-width: 100%;
    border: 1px solid var(--border);
    padding: 10px 15px;
    border-radius: 4px;
    width: 90%;
}

.modal-button-div .valider {
    padding: 7px 20px;
    border-radius: 4px;
    background-color: var(--primary);
    border: solid 1px var(--primary);
    color: white;
}

.modal-button-div .valider:disabled {
    background-color: rgb(0, 123, 255, 0.7);
    pointer-events: none;
}

.modal_hr_button {
    margin: 20px 0;
}

.campaigns_statusSelected {
    background-color: var(--primary) !important;
    color: white !important;
}

.campaigns_statusBox {
    padding: 5px 10px;
    border-radius: 4px;
    border: solid 1px var(--primary);
    color: var(--text-primary);
    background-color: var(--bg-card);
}

.campaigns_statusFilters {
    display: flex;
    flex-direction: row;
    gap: 10px;
    align-items: center;
    background-color: var(--bg);
    padding: 10px;
    border-radius: 6px;
    cursor: pointer;
}

.filter_component {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 10px;
}

item_selectMatchingUser {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
}

.linkedUserSelect {
    max-width: 100%;
    border: 1px solid var(--border);
    padding: 5px 10px;
    border-radius: 4px;
    background-color: var(--bg);
}

.linkedUserNotSelect {
    max-width: 100%;
    padding: 5px 10px;
    border-radius: 4px;
}

.linkedUserSelect p,
.linkedUserNotSelect p {
    margin: 0;
    padding: 0;
}

ul {
    list-style: none;
    padding: 0;
    margin: 0;
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-bottom: 10px;
}

.users_list_box {
    position: absolute;
    background-color: var(--bg-card);
    max-width: 100%;
    display: flex;
    flex-direction: column;
    gap: 4px;
    max-height: 150px;
    overflow-y: scroll;
    width: 100%;
    top: 100%;
    left: 0;
    right: 0;
    z-index: 10;
    padding: 10px;
    border: 1px solid var(--border);
    border-radius: 4px;
}

.input_sleectedUser {
    position: relative;
}

.modal_input_container {
    margin-bottom: 20px;
}

.relative {
    position: relative;
}

.delete_item_select {
    position: absolute;
    right: 5px;
    top: 50%;
    transform: translateY(-50%);
    cursor: pointer;
    background-color: var(--primary);
    border-radius: 50%;
    color: #fff;
    width: 20px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
}

.campaigns_matching_users_box {
    overflow-y: scroll;
    max-height: 450px;
}

.campaigns_creation_box {
    display: flex;
    flex-direction: row;
    justify-content: end;
}


.campaigns_creation_amount_input {
    max-width: 30%;
    border: 1px solid var(--border);
    padding: 10px 15px;
    border-radius: 4px;
    width: 20%;
}

.campaigns_creation_bic_input,
.campaigns_creation_iban_input {
    max-width: 30%;
    border: 1px solid var(--border);
    padding: 10px 15px;
    border-radius: 4px;
    width: 70%;
}




/*********************************************** TOGGLE CSS *************************************************/
.toggle {
  cursor: pointer;
  display: inline-block;
}

.toggle-switch {
  display: inline-block;
  background: #ccc;
  border-radius: 16px;
  width: 29px;
  height: 16px;
  position: relative;
  vertical-align: middle;
  transition: background 0.25s;
}

.toggle-switch:before,
.toggle-switch:after {
  content: "";
}

.toggle-switch:before {
  display: block;
  background: linear-gradient(to bottom, #fff 0%, #eee 100%);
  border-radius: 50%;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.25);
  width: 12px;
  height: 12px;
  position: absolute;
  top: 2px;
  left: 2px;
  transition: left 0.25s;
}

.toggle:hover .toggle-switch:before {
  background: linear-gradient(to bottom, #fff 0%, #fff 100%);
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.5);
}

.toggle-checkbox:checked+.toggle-switch {
  background: var(--primary);
}

.toggle-checkbox:checked+.toggle-switch:before {
  left: 15px;
}

.toggle-checkbox {
  position: absolute;
  visibility: hidden;
}

.toggle-label {
  margin-left: 5px;
  position: relative;
  top: 2px;
}

@media screen and (min-width: 1600px) {}


`, "",{"version":3,"sources":["webpack://./src/pages/campaigns/subpages/CampaignsList/campaignList.css"],"names":[],"mappings":"AAAA;IACI,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,cAAc;IACd,iBAAiB;IACjB,qBAAqB;AACzB;;;AAGA;IACI,4BAA4B;AAChC;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,2BAA2B;IAC3B,kBAAkB;IAClB,2BAA2B;IAC3B,0BAA0B;AAC9B;;AAEA;IACI,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,gCAAgC;IAChC,0BAA0B;AAC9B;;AAEA,gDAAgD;AAChD;IACI,gBAAgB;IAChB,wBAAwB;IACxB,qBAAqB;IACrB,gCAAgC;IAChC,+BAA+B;IAC/B,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,eAAe;IACf,aAAa;AACjB;;AAEA,0DAA0D;AAC1D;IACI,2BAA2B;AAC/B;;AAEA,kDAAkD;AAClD;IACI,4BAA4B;IAC5B,gDAAgD;AACpD;;;AAGA;IACI,2BAA2B;IAC3B,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,YAAY;IACZ,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,oBAAoB;IACpB,SAAS;IACT,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,+BAA+B;IAC/B,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,SAAS;IACT,WAAW;AACf;;AAEA;IACI,eAAe;IACf,+BAA+B;IAC/B,kBAAkB;IAClB,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,gCAAgC;IAChC,gCAAgC;IAChC,YAAY;AAChB;;AAEA;IACI,uCAAuC;IACvC,oBAAoB;AACxB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,2CAA2C;IAC3C,uBAAuB;AAC3B;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,gCAAgC;IAChC,0BAA0B;IAC1B,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,mBAAmB;IACnB,2BAA2B;IAC3B,aAAa;IACb,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,eAAe;IACf,+BAA+B;IAC/B,iBAAiB;IACjB,kBAAkB;IAClB,2BAA2B;AAC/B;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;;IAEI,SAAS;IACT,UAAU;AACd;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,SAAS;IACT,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,gCAAgC;IAChC,eAAe;IACf,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,OAAO;IACP,QAAQ;IACR,WAAW;IACX,aAAa;IACb,+BAA+B;IAC/B,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,2BAA2B;IAC3B,eAAe;IACf,gCAAgC;IAChC,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,oBAAoB;AACxB;;;AAGA;IACI,cAAc;IACd,+BAA+B;IAC/B,kBAAkB;IAClB,kBAAkB;IAClB,UAAU;AACd;;AAEA;;IAEI,cAAc;IACd,+BAA+B;IAC/B,kBAAkB;IAClB,kBAAkB;IAClB,UAAU;AACd;;;;;AAKA,6GAA6G;AAC7G;EACE,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,cAAc;EACd,0DAA0D;EAC1D,kBAAkB;EAClB,yCAAyC;EACzC,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,0DAA0D;EAC1D,wCAAwC;AAC1C;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,QAAQ;AACV;;AAEA,uCAAuC","sourcesContent":[".campaigns-table {\n    width: 100%;\n}\n\ntbody:before {\n    content: \"@\";\n    display: block;\n    line-height: 10px;\n    text-indent: -99999px;\n}\n\n\n.first_th {\n    border-radius: 10px 0 0 10px;\n}\n\n.last_th {\n    border-radius: 0 10px 10px 0;\n}\n\n.campaign_list_title_component {\n    display: flex;\n    flex-direction: row;\n    width: 100%;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.delete_filters {\n    padding: 5px 10px;\n    background-color: var(--bg);\n    border-radius: 4px;\n    border: solid 1px var(--bg);\n    color: var(--text-primary);\n}\n\n.delete_filters:hover {\n    padding: 5px 10px;\n    background-color: #afb7ff;\n    border-radius: 4px;\n    border: solid 1px var(--primary);\n    color: var(--text-primary);\n}\n\n/* styles.css (ou le nom de votre fichier CSS) */\n.custom-select {\n    appearance: none;\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    background-color: var(--bg-card);\n    border: 1px solid var(--border);\n    padding: 5px 10px;\n    border-radius: 4px;\n    font-size: 14px;\n    width: min-content;\n    cursor: pointer;\n    outline: none;\n}\n\n/* Style de survol lorsque la souris passe sur le select */\n.custom-select:hover {\n    border-color: var(--border);\n}\n\n/* Style de focus lorsque le select est en focus */\n.custom-select:focus {\n    border-color: var(--primary);\n    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);\n}\n\n\nth {\n    background-color: var(--bg);\n    padding: 20px 10px;\n    text-align: left;\n}\n\n.payout_modalContainer {\n    position: block;\n    width: 100%;\n    height: 100%;\n    background-color: aqua;\n}\n\n.campaigns_filter_component {\n    display: flex;\n    align-items: center;\n    justify-content: end;\n    gap: 10px;\n    width: 20%;\n}\n\n.campaigns_filter_component input {\n    width: max-content;\n    border: 1px solid var(--border);\n    padding: 5px 10px;\n    border-radius: 4px;\n}\n\n.modal_input_container {\n    display: flex;\n    flex-direction: column;\n    position: relative;\n    gap: 15px;\n    width: 100%;\n}\n\n.modal_input_container input {\n    max-width: 100%;\n    border: 1px solid var(--border);\n    padding: 10px 15px;\n    border-radius: 4px;\n    width: 90%;\n}\n\n.modal-button-div .valider {\n    padding: 7px 20px;\n    border-radius: 4px;\n    background-color: var(--primary);\n    border: solid 1px var(--primary);\n    color: white;\n}\n\n.modal-button-div .valider:disabled {\n    background-color: rgb(0, 123, 255, 0.7);\n    pointer-events: none;\n}\n\n.modal_hr_button {\n    margin: 20px 0;\n}\n\n.campaigns_statusSelected {\n    background-color: var(--primary) !important;\n    color: white !important;\n}\n\n.campaigns_statusBox {\n    padding: 5px 10px;\n    border-radius: 4px;\n    border: solid 1px var(--primary);\n    color: var(--text-primary);\n    background-color: var(--bg-card);\n}\n\n.campaigns_statusFilters {\n    display: flex;\n    flex-direction: row;\n    gap: 10px;\n    align-items: center;\n    background-color: var(--bg);\n    padding: 10px;\n    border-radius: 6px;\n    cursor: pointer;\n}\n\n.filter_component {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: center;\n    gap: 10px;\n}\n\nitem_selectMatchingUser {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.linkedUserSelect {\n    max-width: 100%;\n    border: 1px solid var(--border);\n    padding: 5px 10px;\n    border-radius: 4px;\n    background-color: var(--bg);\n}\n\n.linkedUserNotSelect {\n    max-width: 100%;\n    padding: 5px 10px;\n    border-radius: 4px;\n}\n\n.linkedUserSelect p,\n.linkedUserNotSelect p {\n    margin: 0;\n    padding: 0;\n}\n\nul {\n    list-style: none;\n    padding: 0;\n    margin: 0;\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    margin-bottom: 10px;\n}\n\n.users_list_box {\n    position: absolute;\n    background-color: var(--bg-card);\n    max-width: 100%;\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n    max-height: 150px;\n    overflow-y: scroll;\n    width: 100%;\n    top: 100%;\n    left: 0;\n    right: 0;\n    z-index: 10;\n    padding: 10px;\n    border: 1px solid var(--border);\n    border-radius: 4px;\n}\n\n.input_sleectedUser {\n    position: relative;\n}\n\n.modal_input_container {\n    margin-bottom: 20px;\n}\n\n.relative {\n    position: relative;\n}\n\n.delete_item_select {\n    position: absolute;\n    right: 5px;\n    top: 50%;\n    transform: translateY(-50%);\n    cursor: pointer;\n    background-color: var(--primary);\n    border-radius: 50%;\n    color: #fff;\n    width: 20px;\n    height: 20px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 1000;\n}\n\n.campaigns_matching_users_box {\n    overflow-y: scroll;\n    max-height: 450px;\n}\n\n.campaigns_creation_box {\n    display: flex;\n    flex-direction: row;\n    justify-content: end;\n}\n\n\n.campaigns_creation_amount_input {\n    max-width: 30%;\n    border: 1px solid var(--border);\n    padding: 10px 15px;\n    border-radius: 4px;\n    width: 20%;\n}\n\n.campaigns_creation_bic_input,\n.campaigns_creation_iban_input {\n    max-width: 30%;\n    border: 1px solid var(--border);\n    padding: 10px 15px;\n    border-radius: 4px;\n    width: 70%;\n}\n\n\n\n\n/*********************************************** TOGGLE CSS *************************************************/\n.toggle {\n  cursor: pointer;\n  display: inline-block;\n}\n\n.toggle-switch {\n  display: inline-block;\n  background: #ccc;\n  border-radius: 16px;\n  width: 29px;\n  height: 16px;\n  position: relative;\n  vertical-align: middle;\n  transition: background 0.25s;\n}\n\n.toggle-switch:before,\n.toggle-switch:after {\n  content: \"\";\n}\n\n.toggle-switch:before {\n  display: block;\n  background: linear-gradient(to bottom, #fff 0%, #eee 100%);\n  border-radius: 50%;\n  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.25);\n  width: 12px;\n  height: 12px;\n  position: absolute;\n  top: 2px;\n  left: 2px;\n  transition: left 0.25s;\n}\n\n.toggle:hover .toggle-switch:before {\n  background: linear-gradient(to bottom, #fff 0%, #fff 100%);\n  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.5);\n}\n\n.toggle-checkbox:checked+.toggle-switch {\n  background: var(--primary);\n}\n\n.toggle-checkbox:checked+.toggle-switch:before {\n  left: 15px;\n}\n\n.toggle-checkbox {\n  position: absolute;\n  visibility: hidden;\n}\n\n.toggle-label {\n  margin-left: 5px;\n  position: relative;\n  top: 2px;\n}\n\n@media screen and (min-width: 1600px) {}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
